// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: inline-block;
  height: 100%;
  overflow-y: scroll;
  background-color: rgba(0, 0, 0, 0.8);
  margin: 0 auto;
}

h3 {
  color: white;
  width: 100%;
  text-align: center;
}

img {
  display: inline-block;
}

.twitterTogglerImg {
  display: inline-block;
  width: 60px;
  height: 60px;
  padding: 12px;
  margin: auto;
  position: absolute;
  top: 100px;
  cursor: pointer;
  transition: opacity 0.3s ease;
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

@media screen and (max-width: 768px) {
  .twitterTogglerImg {
    top: 80vh;
  }
}
.twitterdisplay {
  overflow-y: scroll;
  width: 0;
  padding-right: 35px;
  transition: width 0.3s ease;
}

.twitterdisplay:not(.collapsed) {
  width: 500px;
  max-width: 40vw;
}

@media screen and (max-width: 768px) {
  .twitterdisplay:not(.collapsed) {
    width: 100vw;
    max-width: 100vw;
  }
}
.collapsed {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.buttonRow {
  margin-top: 100px;
  margin-bottom: 100px;
}
.buttonRow .btn {
  background-color: #097272;
  color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/app/bluesky/bluesky.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,cAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,6BAAA;EACA,uBAAA;EACA,mBAAA;EACA,yCAAA;AACF;;AAEA;EACE;IACE,SAAA;EACF;AACF;AAEA;EACE,kBAAA;EACA,QAAA;EACA,mBAAA;EACA,2BAAA;AAAF;;AAGA;EACE,YAAA;EACA,eAAA;AAAF;;AAGA;EACE;IACE,YAAA;IACA,gBAAA;EAAF;AACF;AAGA;EACE,0BAAA;EACA,2BAAA;AADF;;AAIA;EACE,iBAAA;EACA,oBAAA;AADF;AAEE;EACE,yBAAA;EACA,cAAA;AAAJ","sourcesContent":[".container {\n  display: inline-block;\n  height: 100%;\n  overflow-y: scroll;\n  background-color: rgba($color: #000000, $alpha: 0.8);\n  margin: 0 auto;\n}\n\nh3 {\n  color: white;\n  width: 100%;\n  text-align: center;\n}\n\nimg {\n  display: inline-block;\n}\n\n.twitterTogglerImg {\n  display: inline-block;\n  width: 60px;\n  height: 60px;\n  padding: 12px;\n  margin: auto;\n  position: absolute;\n  top: 100px;\n  cursor: pointer;\n  transition: opacity 0.3s ease;\n  background-color: white;\n  border-radius: 16px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n@media screen and (max-width: 768px) {\n  .twitterTogglerImg {\n    top: 80vh;\n  }\n}\n\n.twitterdisplay {\n  overflow-y: scroll;\n  width: 0;\n  padding-right: 35px;\n  transition: width 0.3s ease;\n}\n\n.twitterdisplay:not(.collapsed) {\n  width: 500px;\n  max-width: 40vw;\n}\n\n@media screen and (max-width: 768px) {\n  .twitterdisplay:not(.collapsed) {\n    width: 100vw;\n    max-width: 100vw;\n  }\n}\n\n.collapsed {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n.buttonRow {\n  margin-top: 100px;\n  margin-bottom: 100px;\n  .btn {\n    background-color: #097272;\n    color: #ffffff;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
